export default class Errors {
    constructor(errors) {
        this.displayableErrors = [
            'issue',
            'overridden_division_slug',
            'first_name',
            'last_name',
            'phone',
            'phone_alt',
            'email',
            'sms_opted_in',
        ];

        this.errors = {};

        if (typeof errors === 'object') {
            this.errors = errors;
        }
    }

    has(field) {
        return this.errors.hasOwnProperty(field);
    }

    any() {
        return this.count() > 0;
    }

    count() {
        return Object.keys(this.errors).length;
    }

    nonDisplayableCount() {
        return Object.keys(this.errors).filter(item => !this.displayableErrors.includes(item)).length;
    }

    anyNonDisplayable() {
        return Object.keys(this.errors).filter(item => !this.displayableErrors.includes(item)).length > 0;
    }

    onlyDisplayableErrors() {
        return this.any() && !this.anyNonDisplayable();
    }

    onlyNonDisplayableErrors() {
        return this.count() == this.nonDisplayableCount();
    }

    get(field) {
        if (this.errors[field]) {
            return this.errors[field][0];
        }
    }

    capture(errors) {
        this.errors = errors;
    }

    clear(field) {
        delete this.errors[field];
    }
}
